var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"captchaV3-wrapper"}},[_c('div',{attrs:{"id":"captchav3"}})])])
}]

export { render, staticRenderFns }